<template>
  <div :class="['golf-outewr', dataReady ? 'loaded' : '']" v-if="currentLevel.name === 'Silver'">
    <div class="home-page success-component">
      <div class="fourth-block-inner">
        <div class="level-flag-outer">
          <div class="court-img-inner bronze-level">
            <bronze-court v-if="currentLevel.name === 'Silver'"></bronze-court>
          </div>
          <div class="player-img">
            <img src="/static/images/player-img.svg" alt="Vörður" />
          </div>
        </div>
        <h2>Það var lagið!</h2>
        <p class="new-text">Til að halda áfram þarftu að skrá þig inn. Þú ert skrefi nær Regluverðinum.</p>
        <div class="medal-button">
          <button class="button btn-svara" type="button" v-on:click="$emit('showGreeting')">
            Innskráning
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global FB */
/* eslint no-undef: "error" */
import BronzeCourt from '@/components/courts/BronzeCourt'
export default {
  name: 'SuccessComponent',
  props: ['currentLevel'],
  components: {
    BronzeCourt,
  },
  data () {
    return {
      dataReady: false
    }
  },
  methods: {
    sharePage () {
      var passvalue = 'bronze'
      if(this.currentLevel.name.toLowerCase() === 'silver'){
        passvalue = 'bronze'
      } else if (this.currentLevel.name.toLowerCase() === 'gold'){
        passvalue = 'silver'
      } else if (this.$data.globalData.user.completed_quiz){
        passvalue = 'prime'
      } else {
        passvalue = 'gold'
      }
      // let urlToShare = this.$data.globalData.hosted_domain + '/?refer_page=' + passvalue + '&utm_source=leikur&utm_medium=deiling&utm_campaign=golfleikur2019&utm_content=Byrjandi'
      // + passvalue
      //  urlToShare = encodeURI(urlToShare)
      // window.open("https://www.facebook.com/sharer/sharer.php?u=" + urlToShare, "pop", "width=600, height=400, scrollbars=no");

      // Temp Fix until the app is approved 
    
      gtag('config', this.$data.globalData.google_track_id, {
        'page_title' : 'Facebook Share',
        'page_path': this.$data.globalData.hosted_domain + '/?refer_page=' + passvalue
      })
      
      FB.ui({
        method: 'share',
        href: this.$data.globalData.hosted_domain + '/?refer_page=' + passvalue
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fourth-block-inner {
  max-width: 490px !important;
}
.level-flag-image {
  width: 300px;
  height: 230px;
  position: relative;
  margin: 0 auto;
  .flag {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-28%, -55%);
    z-index: 2;
    width: 100px;
    color: #EAA15B;
    &.silver{
      &.true{
        color: #D5D8C9;
      }
    }
    &.gold{
      color: #D5D8C9;
      &.true{
        color: #FCBD00;
      }
    }
    &.prime{
      color: #FCBD00;
    }
    fill: currentColor;
  }
  .court{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }
  .ball{
    position: absolute;
    left: 30%;
    animation: ball_position 1s linear;
    bottom: 58px;
    width: 50px;
    height: 50px;
    z-index: 1;
  }
}
h2 {
  color: #696865;
  font-size: 36px;
}
.new-text  {
  font-size: 24px;
}
.success-component {
  min-height: 700px;
}
.fourth-block-inner {
  max-width: 465px;
  position: relative;
  margin: 0 auto;
  text-align: center;
  padding-top: 7rem;
}
// .next-level-btn {
//   padding: 0 35px;
// }
.medal-button {
  padding-top: 25px;
  display: block;
  font-size: 0;
  button {
    vertical-align: middle;
    font-size: 18px;
    padding: 11px 30px 9px 30px !important;
  }
  #share_btn {
    border-radius: 0;
    margin-right: 10px;
    background: #346AD2;
    padding: 9px 60px !important;
    border-color: #346AD2;
    border-radius: 2px;
  }
}
@keyframes ball_position {
  0% {
    left: -50%;
  }
  100% {
    left: 30%;
  }
}
@media screen and (max-width: 767px) {
  .medal-button {
    margin: 0 30px;
  }
  .new-text {
    font-size: 16px;
    margin: 0 20px 10px;
  }
  .success-component {
    min-height: initial;
  }
  .court-img-inner {
    padding-bottom: 0;
  }
  .level-flag-image {
    width: 200px;
    height: 180px;
    svg{
      width: 150px;
      height: 100px;
    }
    .flag {
      width: 70px;
    }
    .court{
    }
    .ball{
      width: 30px;
      height: 30px;
    }
  }
}
</style>
